import { _, debug, closestEl, makeGtmCall } from '../utils.js'
import axios from 'axios'
import Loading from '../modules/loading.js'
import Validate from '../modules/validate.js'
import successMessageContainer from '../templates/success.js'
import errorMessageContainer from '../templates/error.js'
export default class FormPost {
    constructor(el) {
        this.form = el
        this.pristine = new Validate(this.form)
        this.responseContainer = this.form.querySelector(
            _('response-container', 'element').str(),
        )
        this.tableListingParent = closestEl(
            _('table-listing').node(),
            this.form,
        )
        if (this.tableListingParent) {
            this.modalMessageContainer = _(
                'modal-message-container',
                'element',
            ).nodeFrom(this.tableListingParent)
        }
        this.action = this.form.dataset.action
        this.defaultErrorMessage =
            'Something has gone quite wrong, please try to refresh your browser or contact us.'
        if (this.responseContainer === null) {
            this.responseContainer = document.createElement('div')
            this.responseContainer.dataset.element = 'response-container'
            this.form.prepend(this.responseContainer)
        }
        this.form.addEventListener('submit', this.onSubmit)
        this.fakeSemiError = {
            data: {
                errors: null,
                result: {
                    message: 'Users deleted successfully, but errors occurred.',
                    content: ['user'],
                    warning: {
                        content: ['user', 'user2'],
                        message:
                            'We were unable to remove the following members:',
                    },
                },
            },
            status: 207,
        }
    }

    showLoading = () => {
        this.responseContainer.innerHTML =
            '<div class="form__loading loading" data-behaviour="loading"></div>'
        _('loading')
            .nodes()
            .map((el) => new Loading(el))
    }

    onSubmit = (e) => {
        e.preventDefault()
        this.showLoading()
        const valid = this.pristine.validate()
        if (!valid) {
            this.handleError(
                false,
                "Please check if you've entered everything correctly",
            )
            return false
        }

        axios({
            method: this.action || 'post',
            url: this.form.dataset.endpoint,
            data: new FormData(this.form),
        })
            .then((response) => {
                if (response.status !== 200) {
                    return this.handleError(response)
                }
                return this.handleSuccess(response)
            })
            .catch((err) => {
                if (err.response && err.response.data) {
                    this.handleError(err.response.data)
                    // uncomment to fake a semi success
                    // this.handleError(this.fakeSemiError)
                } else {
                    this.handleError(err)
                }
            })
    }

    handleSuccess = (response) => {
        if (response.data.result.message) {
            this.responseContainer.innerHTML = successMessageContainer(
                response.data.result.message,
            )
        }
        this.refreshTableListing()

        if (this.form.dataset.form !== 'renew-membership') {
            this.closeModal()
        }
        if (this.form.dataset.form === 'renew-membership') {
            this.responseContainer.innerHTML = ''
            const redirectRadio = _('redirect', 'element').nodeFrom(this.form)
            const showMessageRadio = _('reveal-success', 'element').nodesFrom(
                this.form,
            )
            if (redirectRadio && redirectRadio.checked) {
                window.location.href = redirectRadio.dataset.url
            }
            showMessageRadio?.forEach((radio) => {
                if (radio.checked) {
                    const successMessage = _(
                        radio.dataset.target,
                        'element',
                    ).node()
                    successMessage.classList.remove('u-hidden')
                    this.form.classList.add('u-hidden')
                }
            })
        }

        if (this.tableListingParent) {
            this.modalMessageContainer.innerHTML = successMessageContainer(
                response.data.result.message,
            )
        }

        this.form.dataset.gtmEvent = this.form.dataset.gtmEvent || 'form-submit'
        this.form.dataset.gtmName =
            this.form.dataset.gtmName || this.form.dataset.endpoint
        makeGtmCall(this.form)
        if (this.form.dataset.reset === 'true') {
            this.form.reset()
        }
    }

    refreshTableListing = () => {
        if (this.tableListingParent) {
            const event = new Event('input')
            _('trigger-call')
                .nodeFrom(this.tableListingParent)
                .dispatchEvent(event)
        }
    }

    closeModal = () => {
        const url = new URL(window.location)
        const params = new URLSearchParams(url.search)
        params.delete('modal')
        window.history.pushState(
            null,
            null,
            `${window.location.pathname}${params}${window.location.hash}`,
        )
    }

    handleSemiSuccess = (data) => {
        this.refreshTableListing()
        let successfulContentHTML = ''
        data.result.content.map((item) => {
            successfulContentHTML += `<li>${item}</li>`
        })
        let failedContentHTML = ''
        data.result.warning.content.map((item) => {
            failedContentHTML += `<li>${item}</li>`
        })

        if (this.tableListingParent) {
            this.modalMessageContainer.innerHTML =
                successMessageContainer(`<div class="wysiwyg u-align-left">
            <p>${data.result.message}</p>
            <ul>${successfulContentHTML}</ul>
            </div>`) +
                errorMessageContainer(`<div class="wysiwyg u-align-left u-mb">
            <p>${data.result.warning.message}</p>
            <ul>${failedContentHTML}</ul>
            </div>`)
        }
        this.form.reset()
        this.closeModal()
    }

    handleError = (err, defaultMessage = this.defaultErrorMessage) => {
        if (debug) {
            console.warn({ err })
        }

        if (err && err.status === 207) {
            if (debug) {
                console.warn(
                    'only some operations were successful, some failed',
                )
            }
            return this.handleSemiSuccess(err.data)
        }
        let errorHTML = `<p>${defaultMessage}</p>`

        if (err && err.errors) {
            errorHTML = `<p>${err.errors}</p>`
        }

        if (
            this.responseContainer.dataset.customError &&
            !(err && err.errors)
        ) {
            errorHTML = `<p>${this.responseContainer.dataset.customError}</p>`
        }

        this.responseContainer.innerHTML = errorMessageContainer(errorHTML)
    }
}
